module.exports = __webpack_public_path__ + "img/address 6@2x.dc22509b.png";